import React from "react";

/**
 * Button. All primitive `<button>` props pass through.
 * @param {Object} props
 * @param {"primary"|"secondary"|"ghost"|"danger"} [props.variant="primary"]
 * @param {"sm"|"md"|"lg"} [props.size="md"]
 * @param {boolean} [props.loading]
 * @param {boolean} [props.iconOnly]
 */
export function Button({
  variant = "primary", size = "md", loading = false, iconOnly = false,
  className = "", children, disabled, ...rest
}) {
  const cls = [
    "btn",
    `btn-${variant}`,
    size !== "md" && `btn-${size}`,
    iconOnly && "btn-icon-only",
    className,
  ].filter(Boolean).join(" ");
  return (
    <button className={cls} disabled={disabled || loading} {...rest}>
      {loading && <span className="btn-spinner" aria-hidden />}
      {children}
    </button>
  );
}
